import {
  AutoGenerateScoreEvalConfigRequest,
  AutoGenerateScoreEvalConfigResponse,
} from '@/types';
import { apiRequest } from '@/utils/api-request';

export const autoGenerateScoreEvalConfig = async (
  body: AutoGenerateScoreEvalConfigRequest,
): Promise<AutoGenerateScoreEvalConfigResponse> => {
  const response = await apiRequest<AutoGenerateScoreEvalConfigResponse>({
    url: '/evaluations/auto_generate_score_eval_config',
    target: 'platform',
    method: 'POST',
    body: body as unknown as Record<string, unknown>,
  });

  if (response.success === false) {
    throw new Error(response.detail);
  }

  return response?.data as AutoGenerateScoreEvalConfigResponse;
};
